import {Pipe, PipeTransform} from '@angular/core';
import {ElaborationDto} from '../../../Models/YuChef/Elaborations/elaboration.interface';

@Pipe({
  name: 'elaborations',
  standalone: false
})
export class ElaborationsPipe implements PipeTransform {

  transform(items: ElaborationDto[], filters: { id_local?: number, id_familia?: number }): ElaborationDto[] {

    if (!items.length) {
      return [];
    }

    if (filters.id_familia) {
      items = items.filter((item) => item.id_familia === filters.id_familia);
    }

    if (filters.id_local) {
      items = items.filter((item) => !item.ids_locales || item.ids_locales.includes(Number(filters.id_local)));
    }

    return items;

  }

}
